(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/react/accessibility/accessibility-carousel-nav-button.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/react/accessibility/accessibility-carousel-nav-button.js');

'use strict';

const clx = svs.components.lbUtils.clx;
const AccessibilityCarouselNavButton = _ref => {
  let className = _ref.className,
    disabled = _ref.disabled,
    label = _ref.label,
    onClick = _ref.onClick;
  return React.createElement("button", {
    "aria-disabled": disabled,
    "aria-label": label,
    className: clx(className, 'a11y-carousel-nav-button', {
      'a11y-carousel-nav-button-disabled': disabled
    }),
    onClick: onClick,
    type: "button"
  }, label);
};
AccessibilityCarouselNavButton.defaultOptions = {
  disabled: false
};
setGlobal('svs.components.lbUi.carousel.accessibility.AccessibilityCarouselNavButton', AccessibilityCarouselNavButton);

 })(window);